var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block without-footer current-level"},[_c('div',{staticClass:"header"},[_c('span',[_vm._v("現在水位")]),_c('span',[_vm._v(_vm._s(_vm.last_update))])]),_c('div',{staticClass:"body"},[_c('canvas',{ref:"canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }